<div class="bg-white px-5 py-4 shadow-(--shadow-input) rounded-2xl transition
    relative {{ customClass }}" [ngClass]=" {
        'focus-within:ring-1 focus-within:ring-blue-500' :!hasError, 
        'ring-1 ring-(--color-error)' : hasError }">
    <!-- Label -->
    <label class="block font-medium text-base" [ngClass]="{
        'text-(--text-secondary)' : !hasError,
        'text-(--color-error)': hasError
    }">
        {{ label }}
    </label>

    <!-- Input field -->
    <input [type]="inputType" [placeholder]="placeholder" [formControl]="control!"
        class="input-field placeholder:text-(--text-placeholder) w-full rtl:pr-0 pr-10" />

    <!-- Toggle icon -->
    <button type="button" (click)="toggleVisibility()"
        class="absolute rtl:right-auto rtl:left-6 right-6 top-14 transform -translate-y-1/2 cursor-pointer">
        <img *ngIf="showPassword" src="assets/icons/eye-hide.svg" alt="Hide password"
            class="w-5 h-5 hover:opacity-80" />
        <img *ngIf="!showPassword" src="assets/icons/eye-show.svg" alt="Show password"
            class="w-5 h-5 hover:opacity-80" />
    </button>
</div>

<!-- Error Message -->
<p *ngIf="showError" class="text-(--color-error) text-sm mt-0 font-medium mb-4">
    Enter a valid password
</p>